import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowLineRight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 38,
	height: 22,
	viewBox: "0 0 38 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		filter: "url(#filter0_b_2981_321)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M0 11C0 4.92487 4.92487 0 11 0H27C33.0751 0 38 4.92487 38 11C38 17.0751 33.0751 22 27 22H11C4.92487 22 0 17.0751 0 11Z",
				fill: "none",
				fillOpacity: .4
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.5 11C0.5 5.20101 5.20101 0.5 11 0.5H27C32.799 0.5 37.5 5.20101 37.5 11C37.5 16.799 32.799 21.5 27 21.5H11C5.20101 21.5 0.5 16.799 0.5 11Z",
				stroke: "none"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M22.372 10.6905C22.4127 10.7311 22.445 10.7794 22.467 10.8325C22.489 10.8856 22.5003 10.9425 22.5003 11C22.5003 11.0575 22.489 11.1144 22.467 11.1675C22.445 11.2206 22.4127 11.2689 22.372 11.3095L18.4345 15.247C18.3939 15.2877 18.3456 15.3199 18.2925 15.3419C18.2394 15.3639 18.1825 15.3752 18.125 15.3752C18.0675 15.3752 18.0106 15.3639 17.9575 15.3419C17.9044 15.3199 17.8561 15.2877 17.8155 15.247C17.7748 15.2064 17.7426 15.1581 17.7206 15.105C17.6986 15.0519 17.6873 14.995 17.6873 14.9375C17.6873 14.88 17.6986 14.8231 17.7206 14.77C17.7426 14.7169 17.7748 14.6686 17.8155 14.628L21.0065 11.4375H13.75C13.634 11.4375 13.5227 11.3914 13.4406 11.3094C13.3586 11.2273 13.3125 11.116 13.3125 11C13.3125 10.884 13.3586 10.7727 13.4406 10.6906C13.5227 10.6086 13.634 10.5625 13.75 10.5625H21.0065L17.8155 7.37203C17.7334 7.28994 17.6873 7.1786 17.6873 7.0625C17.6873 6.9464 17.7334 6.83506 17.8155 6.75297C17.8976 6.67088 18.0089 6.62476 18.125 6.62476C18.2411 6.62476 18.3524 6.67088 18.4345 6.75297L22.372 10.6905ZM23.8125 5.75C23.6965 5.75 23.5852 5.79609 23.5031 5.87814C23.4211 5.96019 23.375 6.07147 23.375 6.1875V15.8125C23.375 15.9285 23.4211 16.0398 23.5031 16.1219C23.5852 16.2039 23.6965 16.25 23.8125 16.25C23.9285 16.25 24.0398 16.2039 24.1219 16.1219C24.2039 16.0398 24.25 15.9285 24.25 15.8125V6.1875C24.25 6.07147 24.2039 5.96019 24.1219 5.87814C24.0398 5.79609 23.9285 5.75 23.8125 5.75Z",
				fill: "currentColor"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
		id: "filter0_b_2981_321",
		x: -20,
		y: -20,
		width: 78,
		height: 62,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", {
				in: "BackgroundImageFix",
				stdDeviation: 10
			}),
			/* @__PURE__ */ _jsx("feComposite", {
				in2: "SourceAlpha",
				operator: "in",
				result: "effect1_backgroundBlur_2981_321"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_backgroundBlur_2981_321",
				result: "shape"
			})
		]
	}) })]
});
export default SvgArrowLineRight;
